export const RAF_PULSE_GOLD = '#d0aa46';
export const RAF_PULSE_DARK_SLATE = '#516272';
